/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface RulesLightDto { 
    id?: number;
    name?: string;
    author?: string;
    revision?: number;
    uuid?: string;
    localizedNames?: { [key: string]: string; };
    localizedDescriptions?: { [key: string]: string; };
    version?: number;
    createdDate?: Date;
    lastModifiedDate?: Date;
}